import React from 'react'
import { X } from 'lucide-react'
import AuthForm from './AuthForm'

interface AuthViewProps {
  onBack?: () => void
  initialMode?: 'signIn' | 'signUp'
}

export default function AuthView({ onBack, initialMode }: AuthViewProps): React.JSX.Element {
  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        width: '100vw',
        background:
          'radial-gradient(circle at top right, color-mix(in srgb, var(--brand-color) 8%, transparent), transparent), radial-gradient(circle at bottom left, color-mix(in srgb, var(--brand-color) 5%, transparent), transparent), var(--bg-color)',
        padding: '24px',
        overflowY: 'auto'
      }}
    >
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Back to landing page"
          style={{
            position: 'absolute',
            top: '24px',
            left: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '36px',
            height: '36px',
            borderRadius: '999px',
            background: 'rgba(255, 255, 255, 0.06)',
            border: 'none',
            color: 'var(--text-muted)',
            cursor: 'pointer'
          }}
        >
          <X size={18} />
        </button>
      )}
      <AuthForm initialMode={initialMode} />
    </div>
  )
}
